import { render, staticRenderFns } from "./AgreementDialog.vue?vue&type=template&id=5c12be93&scoped=true&"
import script from "./AgreementDialog.vue?vue&type=script&lang=js&"
export * from "./AgreementDialog.vue?vue&type=script&lang=js&"
import style0 from "./AgreementDialog.vue?vue&type=style&index=0&id=5c12be93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12be93",
  null
  
)

export default component.exports